module.exports = __webpack_public_path__ + "static/media/dcd-tab-sm.01bde6b4.svg";